import { useFetchGetProductoServicioById } from "@/shared/actions/erp/producto_servicio.action";
import SaveProductoServicio from "../../shared/componente/save_producto_servicio/SaveProductoServicio";
import { Navigate, useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";

export default function UpdateProductoServicioPage() {

  const { id } = useParams();

  const {
    data,
    isLoading
  } = useFetchGetProductoServicioById(id!, true);

  if (isLoading) {
    return <LoaderComponent />
  }

  if (!data) {
    return <Navigate to={ROUTER_PATHS.inventario.servicio} />
  }

  return (
    <SaveProductoServicio
      title="Editar Servicio"
      productoServicio={data}
    />
  )

}